import React from 'react';
import { Routes, Route } from 'react-router-dom';
import List from './List';
import Form from './Form';

const MatchPlayerGroupConfigResource = () => {

  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/create" element={<Form />} />
      <Route path="/:id" element={<Form />} />
    </Routes>
  );
};

export default MatchPlayerGroupConfigResource; 